// extracted by mini-css-extract-plugin
export default {"content":"_3BJcq","scrollable":"_10od9","bannerList1":"Sod1z","matchOfTheDay":"_3SD7W","aviatorBanner":"_3szWB"};